import { CognitoUserPool } from "amazon-cognito-identity-js";
const REACT_APP_USER_POOL_ID = process.env.REACT_APP_USER_POOL_ID;
const REACT_APP_CLIENT_ID = process.env.REACT_APP_CLIENT_ID;

const userPoolId =REACT_APP_USER_POOL_ID;
const clientId = REACT_APP_CLIENT_ID;

const poolData = new CognitoUserPool({
    UserPoolId: userPoolId,
    ClientId: clientId
})

export default (poolData);